'use client';

import { useEffect } from 'react';

import {
    isLoginProvider,
    LOGIN_PROVIDER_STORAGE_KEY,
    PENDING_LOGIN_PROVIDER_STORAGE_KEY,
} from '@utils/login-provider-preference';

export default function LoginProviderPreferenceRecorder({ authenticated }: { authenticated: boolean }): null {
    useEffect(() => {
        if (!authenticated) {
            return;
        }

        const pendingProvider = sessionStorage.getItem(PENDING_LOGIN_PROVIDER_STORAGE_KEY);
        if (isLoginProvider(pendingProvider)) {
            localStorage.setItem(LOGIN_PROVIDER_STORAGE_KEY, pendingProvider);
        }
        sessionStorage.removeItem(PENDING_LOGIN_PROVIDER_STORAGE_KEY);
    }, [authenticated]);

    return null;
}
